import React, { lazy } from 'react';

const BuyerIdentityComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-buyer-identity" */ './buyer-identity')
);

export const BuyerIdentityRoute = () => <BuyerIdentityComponent />;
